module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.d95c91e.eot";